import styled from "styled-components";
import { color, typeStyle } from "@m/alchemy-theme";
export const Text = styled.p `
  ${(props) => typeStyle(props.typeStyle || "bodyS")};

  a {
    color: ${color("typeLink")};
    ${typeStyle("link")};
  }

  color: ${(props) => (props.color ? color(props.color) : "")};
`;
